module.exports = __webpack_public_path__ + "static/media/cny2022.dac2605d.png";